import { ResourcesKey, translate } from "@modules/localizations/translate";

const TranslatedTextTemp = ({
  text,
  origintext,
  className,
  onClick,
}: {
  text: string | ResourcesKey;
  origintext?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}) => {
  return (
    <div className={`dark:text-white ${className}`} onClick={onClick}>
      {translate(text as ResourcesKey) || origintext}
    </div>
  );
};

export default TranslatedTextTemp;
